import './index.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import BotTabTableContainer from '../../../BotTabTableContainer';
import { fetchImportDeltas } from '../../../actions';
import CONSTS from 'constants/index.js';
import {
  GECKO_CONSTS,
  GeckoTable,
  GeckoPagination,
  GeckoModalService,
  GeckoToastService,
  GeckoAlert,
  GeckoModal,
  GeckoBtns,
  GeckoCard,
} from 'ui';
import { renderError } from 'services/gecko-error';
import GeckoLocation from 'services/gecko-location';
import ImportReviewService from './Service';
import DeltaSummary from './DeltaSummary';
import DeltaChangesWrapper from './DeltaChangesWrapper';
import DeltaActions from './DeltaActions';
import DeltaModal from './DeltaModal';

class BotAnswersImportReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
    };
  }

  componentDidMount() {
    // Fetch import deltas
    fetchImportDeltas({
      page: this.props.page ? this.props.page : 1,
      botId: this.props.botId,
      importId: this.props.importId,
    });
  }

  cols = [
    {
      name: 'Name',
      key: 'response_name',
      width: '40%',
    },
    {
      name: 'Changes',
      key: 'diffs',
      type: GECKO_CONSTS.TABLE_CELL_CUSTOM,
      width: '60%',
      render: (diffs, row) => (
        <DeltaChangesWrapper
          className="BotAnswersImportReview-deltaChangesRow"
          limit={2}
          showOverflow={true}
          diffs={diffs}
          deltaId={row.id}
        />
      ),
    },
    {
      name: 'Approve',
      key: 'id',
      type: GECKO_CONSTS.TABLE_CELL_CUSTOM,
      render: (deltaId, answer) => (
        <DeltaActions
          deltaId={deltaId}
          botId={answer.bot_id}
          importId={this.props.importId}
        />
      ),
    },
  ];

  rowHandler(delta) {
    return new GeckoModalService()
      .open(() => (
        <DeltaModal
          botId={this.props.botId}
          importId={this.props.importId}
          deltaId={delta.id}
        />
      ))
      .then(() => {
        // Fetch import deltas
        fetchImportDeltas({
          page: this.props.page,
          botId: this.props.botId,
          importId: this.props.importId,
        });
      })
      .catch(renderError);
  }

  renderCompletionMessage() {
    if (!this.props.deltas.length && !this.props.fetching) {
      return (
        <div className="AnswersImportReview-completionMessage">
          <i className="far fa-check-circle"></i>
          <h1>All modified answers reviewed. Great job!</h1>
          <p>Please confirm the import to save your changes.</p>
        </div>
      );
    }
    return null;
  }

  renderNoDeltasMessage() {
    if (!this.props.deltas.length && this.props.fetching) {
      return (
        <GeckoAlert type={GECKO_CONSTS.ALERT_TYPE_WARNING}>
          This bot import hasn't got any deltas to review.
        </GeckoAlert>
      );
    }
    return null;
  }

  renderDeltasTable() {
    if (this.props.deltas.length) {
      const pagination = {
        changePage: (page) =>
          fetchImportDeltas({
            botId: this.props.botId,
            importId: this.props.importId,
            page,
          }),
        current_page: this.props.page,
        total_items: this.props.total,
        total_pages: Math.ceil(this.props.total / 20),
      };
      return (
        <div>
          <GeckoTable
            cols={this.cols}
            rows={this.props.deltas || []}
            rowHandler={this.rowHandler.bind(this)}
          />
          <GeckoPagination pagination={pagination} />
        </div>
      );
    }
    return null;
  }

  renderReviewContent() {
    if (
      !this.props.import ||
      this.props.import.status === CONSTS.IMPORT_STATUS_REVIEW
    ) {
      return (
        <div className="AnswersImportReview-content">
          {this.renderCompletionMessage()}
          {this.renderNoDeltasMessage()}
          {this.renderDeltasTable()}
        </div>
      );
    }
    return null;
  }

  renderProcessingContent() {
    if (
      this.props.import &&
      [
        CONSTS.IMPORT_STATUS_NEW,
        CONSTS.IMPORT_STATUS_PROCESSING,
        CONSTS.IMPORT_STATUS_COMPLETED,
      ].includes(this.props.import.status)
    ) {
      return (
        <div className="AnswersImportReview-processingMessage">
          <i className="fa fa-spin fa-sync"></i>
          <h1>Processing</h1>
          <p>CSV is currently being processed, this may take a moment.</p>
        </div>
      );
    }
    return null;
  }

  renderCommittingContent() {
    if (
      this.props.import &&
      this.props.import.status === CONSTS.IMPORT_STATUS_COMMITTED
    ) {
      return (
        <div className="AnswersImportReview-processingMessage">
          <i className="fa fa-spin fa-sync"></i>
          <h1>Applying</h1>
          <p>
            Your reviewed import is currently being applied, this may take a
            moment.
          </p>
        </div>
      );
    }
    return null;
  }

  renderFailedValidationContent() {
    if (
      this.props.import &&
      this.props.import.status === CONSTS.IMPORT_STATUS_FAILED_VALIDATION
    ) {
      const btns = [
        {
          name: 'Cancel Import',
          icon: 'far fa-times',
          type: GECKO_CONSTS.BTN_TYPE_DEFAULT,
          handler: () => {
            return ImportReviewService.cancel(
              this.props.botId,
              this.props.importId
            )
              .then(() => {
                // Navigate to answers page
                return GeckoLocation.goTo(`/bots/${this.props.botId}/answers`);
              })
              .catch(renderError);
          },
        },
        {
          name: 'Try Again',
          icon: 'far fa-cloud-upload',
          type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
          handler: ImportReviewService.openUploadModal.bind(
            this,
            this.props.botId
          ),
        },
      ];
      return (
        <div className="AnswersImportReview-failedValidation">
          <div className="gecko-card-body padded">
            <GeckoAlert type={GECKO_CONSTS.ALERT_TYPE_DANGER}>
              <p className="AnswersImportReview-caption">
                Please review the errors highlighted below:
              </p>
              <ul>
                {this.props.import.errors.map((err, key) => (
                  <li key={key}>{err}</li>
                ))}
              </ul>
            </GeckoAlert>
          </div>
          <div className="footer">
            <GeckoBtns items={btns} />
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <React.Fragment>
        <DeltaSummary botId={this.props.botId} importId={this.props.importId} />

        <div className="AnswersImportReview">
          <BotTabTableContainer title="Review Import" noCreate={true}>
            {this.renderProcessingContent()}
            {this.renderFailedValidationContent()}
            {this.renderReviewContent()}
            {this.renderCommittingContent()}
          </BotTabTableContainer>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    page: state.botsRoute.deltas.page,
    total: state.botsRoute.deltas.total,
    fetching: state.botsRoute.deltas.fetching,
    import: state.botsRoute.importsById[state.location.slug],
    deltas: state.botsRoute.deltas.ids.map(
      (id) => state.botsRoute.deltasById[id]
    ),
    importId: state.location.slug,
  };
};

export default connect(mapStateToProps)(BotAnswersImportReview);
